import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, Subject} from 'rxjs';
import {environment} from '../../environments/environment';

@Injectable({providedIn: 'root'})
export class AuthService {
  private baseUrl = environment.apiUrl;

  verifyEmailOnLogin: Subject<any> = new Subject();
  passwordResetOtpValidationResult: Subject<{success: boolean; error?: string}> = new Subject();

  constructor(private http: HttpClient) {
  }

  login(data: { email: string; password: string }): Observable<any> {
    return this.http.post(`${this.baseUrl}/v1/login`, data);
  }

  signup(data: { email: string; password: string, confirmPassword: string }): Observable<any> {
    return this.http.post(`${this.baseUrl}/v1/signup`, data);
  }

  verifyEmail(data: { otp: string }): Observable<any> {
    return this.http.post(`${this.baseUrl}/v1/verify-email`, data);
  }

  forgotPassword(data: { email: string }): Observable<any> {
    return this.http.post(`${this.baseUrl}/v1/password/forgot`, data);
  }

  resetPassword(data: { otp: string, password: string, confirmPassword: string }): Observable<any> {
    return this.http.post(`${this.baseUrl}/v1/password/set`, data);
  }

  resendOtp(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/v1/resend`, payload);
  }

  validatePasswordResetOtp(data: { email: string; otp: string }): Observable<any> {
    return this.http.post(`${this.baseUrl}/v1/password/otp/validate`, data);
  }
}
